module.exports = __webpack_public_path__ + "media/img/home/img_id-4c4b90db277c7db31ee7accfc1ab4ee6.png";